/* kh-nospy v1 — content-protection deterrents (NoSpy replacement). ES5.
   Deterrence only: stops casual copy/save and spy browser extensions.
   Never interferes with form fields; paste is never blocked. */
(function () {
  'use strict';
  if (window.__khnsInit) return;
  window.__khnsInit = true;

  var cfg = window.khnsConfig;
  if (!cfg) return;

  var docEl = document.documentElement;

  /* form fields + editable content are always exempt */
  function isEditable(el) {
    while (el && el.nodeType === 1) {
      var tag = el.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
      if (el.isContentEditable) return true;
      if (el.getAttribute) {
        var ce = el.getAttribute('contenteditable');
        if (ce !== null && ce !== 'false') return true;
      }
      el = el.parentNode;
    }
    return false;
  }

  /* ---------- text selection (CSS class; exemptions live in the stylesheet) ---------- */
  if (cfg.textSelection) docEl.classList.add('khns-noselect');

  /* ---------- image dragging ---------- */
  if (cfg.imageDrag) {
    docEl.classList.add('khns-nodrag');
    document.addEventListener('dragstart', function (e) {
      var t = e.target;
      if (t && t.nodeType === 1 && (t.tagName === 'IMG' || t.tagName === 'PICTURE' || t.tagName === 'SVG')) {
        e.preventDefault();
      }
    }, true);
  }

  /* ---------- right click (allowed on form fields so paste/autofill menus work) ---------- */
  if (cfg.rightClick) {
    document.addEventListener('contextmenu', function (e) {
      if (isEditable(e.target)) return;
      e.preventDefault();
    });
  }

  /* ---------- copy / cut of page content (never paste, never form fields) ---------- */
  if (cfg.copyPaste) {
    var blockClip = function (e) {
      if (isEditable(e.target)) return;
      e.preventDefault();
    };
    document.addEventListener('copy', blockClip);
    document.addEventListener('cut', blockClip);
  }

  /* ---------- view-source / save / devtools shortcuts ---------- */
  if (cfg.keysShortcuts) {
    document.addEventListener('keydown', function (e) {
      /* e.code survives Alt/Option key remapping on Mac; e.key does not */
      var code = e.code || '';
      var letter = code.indexOf('Key') === 0 ? code.charAt(3).toLowerCase() : '';
      if (!letter) letter = (e.key || '').toLowerCase();
      var mod = e.ctrlKey || e.metaKey;
      if (e.key === 'F12') { e.preventDefault(); return; }
      if (mod && !e.shiftKey && !e.altKey && (letter === 's' || letter === 'u')) { e.preventDefault(); return; }
      if (mod && e.shiftKey && (letter === 'i' || letter === 'j' || letter === 'c')) { e.preventDefault(); return; }
      if (mod && e.altKey && (letter === 'i' || letter === 'j' || letter === 'c' || letter === 'u')) { e.preventDefault(); }
    });
  }

  /* ---------- legal notice in the console (no flaky devtools "detection") ---------- */
  if (cfg.consoleNotice && window.console && console.log) {
    try {
      console.log('%c' + cfg.notice, 'font-size:16px;font-weight:bold;color:#121212;');
    } catch (err) { /* older consoles ignore %c */ }
  }

  /* ---------- spy browser extensions (PPSPY / Koala / AliHunter / ...) ---------- */
  if (cfg.spyExtensions) {
    var SPY_PATTERN = /(ppspy|koala[-_]?inspector|alihunter|ali[-_]?hunter|shophunter|dropispy|uuspy|simplytrends|commerce[-_]?inspector|shopspy|salesource|niche[-_]?scraper)/i;
    var overlayShown = false;

    function attrsMatch(el) {
      if (!el || el.nodeType !== 1) return false;
      var id = el.id || '';
      var cls = (typeof el.className === 'string') ? el.className : '';
      return SPY_PATTERN.test(id) || SPY_PATTERN.test(cls);
    }

    function showOverlay() {
      if (overlayShown) return;
      overlayShown = true;
      var overlay = document.createElement('div');
      overlay.className = 'khns-overlay';
      var msg = document.createElement('p');
      msg.textContent = cfg.notice;
      overlay.appendChild(msg);
      (document.body || docEl).appendChild(overlay);
    }

    function scan(root) {
      if (attrsMatch(root)) { showOverlay(); return true; }
      if (root && root.querySelectorAll) {
        /* cheap attribute scan over element ids/classes */
        var els = root.querySelectorAll('[id], [class]');
        for (var i = 0; i < els.length; i++) {
          if (attrsMatch(els[i])) { showOverlay(); return true; }
        }
      }
      return false;
    }

    function watch() {
      if (scan(document.body)) return;
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            /* scan() checks the node itself first and owns showing the overlay */
            if (added[j].nodeType === 1 && scan(added[j])) {
              mo.disconnect();
              return;
            }
          }
        }
      });
      mo.observe(docEl, { childList: true, subtree: true });
      /* extensions inject early; stop watching after 30s to stay lightweight */
      window.setTimeout(function () { mo.disconnect(); }, 30000);
    }

    if (document.body) watch();
    else window.addEventListener('DOMContentLoaded', watch);
  }
})();
